'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import ErrorComponent from '@/components/ErrorComponent';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorComponent error={error} context='route-level-error' />;
}
